function PageFooter(){

    return (
        <div className="footer l-box is-center">
        
        </div>   
    )
}

export default PageFooter